import { NOTEBOOK } from 'app/api-routes';
import axios from 'axios';
import { put, all, takeLatest } from 'redux-saga/effects';
import {
  biNotebookNotesByDateAndTagFailure,
  biNotebookNotesByDateAndTagRequest,
  biNotebookNotesByDateAndTagSuccess,
  biNotebookNotesByDateFailure,
  biNotebookNotesByDateRequest,
  biNotebookNotesByDateSuccess,
  biNotebookNotesByTagFailure,
  biNotebookNotesByTagRequest,
  biNotebookNotesByTagSuccess,
  setLoadingState,
} from './actions';
import moment from 'moment';
import { SERVER_DATE_TIME_FORMAT } from 'app/types/constants';
import { formatDateTimeUTC } from 'util/formatting';
import _ from 'lodash';

function* biNotebookNotesByTagSaga({ payload: { siteID, userID, supervisorID, tagIDs, month, year } }) {
  try {
    const startDate = formatDateTimeUTC(moment(`${year}-${month}`).startOf('month'), SERVER_DATE_TIME_FORMAT);
    const endDate = formatDateTimeUTC(moment(`${year}-${month}`).endOf('month'), SERVER_DATE_TIME_FORMAT);
    const params = { startDate, endDate };

    if (userID) {
      params.userID = userID;
    }

    if (siteID) {
      params.siteID = siteID;
    }

    if (supervisorID) {
      params.supervisorID = supervisorID;
    }

    if (!_.isEmpty(tagIDs)) {
      params.tagIDs = tagIDs;
    }

    yield put(biNotebookNotesByTagSuccess([]));

    const { payload } = yield axios.get(`${NOTEBOOK}/grouped-by-tag`, {
      params,
    });

    yield put(biNotebookNotesByTagSuccess(payload));
  } catch (err) {
    yield put(biNotebookNotesByTagFailure(err));
  }
}

function* biNotebookNotesByDateAndTagSaga({
  payload: { month, year, siteID, userID, tagIDs, status, startDate, endDate },
}) {
  try {
    yield put(setLoadingState(true));

    if (!startDate || !endDate) {
      startDate = formatDateTimeUTC(moment(`${year}-${month}`).startOf('month'), SERVER_DATE_TIME_FORMAT);
      endDate = formatDateTimeUTC(moment(`${year}-${month}`).endOf('month'), SERVER_DATE_TIME_FORMAT);
    }
    const params = { startDate, endDate };

    if (siteID) {
      params.siteID = siteID;
    }

    if (userID) {
      params.userID = userID;
    }

    if (!_.isEmpty(tagIDs)) {
      params.tagIDs = tagIDs;
    }

    if (status) {
      params.status = status;
    }

    const { payload } = yield axios.get(`${NOTEBOOK}/grouped-by-date-and-tag`, {
      params,
    });

    yield put(biNotebookNotesByDateAndTagSuccess(payload));
  } catch (err) {
    yield put(biNotebookNotesByDateAndTagFailure(err));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* biNotebookNotesByDateSaga({ payload: { month, year, siteID, userID, tagIDs, status } }) {
  try {
    yield put(setLoadingState(true));

    const startDate = formatDateTimeUTC(moment(`${year}-${month}`).startOf('month'), SERVER_DATE_TIME_FORMAT);
    const endDate = formatDateTimeUTC(moment(`${year}-${month}`).endOf('month'), SERVER_DATE_TIME_FORMAT);
    const params = { startDate, endDate };

    if (siteID) {
      params.siteID = siteID;
    }

    if (userID) {
      params.userID = userID;
    }

    if (!_.isEmpty(tagIDs)) {
      params.tagIDs = tagIDs;
    }

    if (status) {
      params.status = status;
    }

    const { payload } = yield axios.get(`${NOTEBOOK}/grouped-by-date`, {
      params,
    });

    yield put(biNotebookNotesByDateSuccess(payload));
  } catch (err) {
    yield put(biNotebookNotesByDateFailure(err));
  } finally {
    yield put(setLoadingState(false));
  }
}

export default function* () {
  yield all([
    yield takeLatest(biNotebookNotesByTagRequest, biNotebookNotesByTagSaga),
    yield takeLatest(biNotebookNotesByDateAndTagRequest, biNotebookNotesByDateAndTagSaga),
    yield takeLatest(biNotebookNotesByDateRequest, biNotebookNotesByDateSaga),
  ]);
}
